import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import appReducer from '../../store/app/appSlice';
import { facadeApiV2 } from '../../store/facade/facadeApiV2';
import { facadeApiV3 } from '../../store/facade/facadeApiV3';
import filterReducer from '../../store/filter/filterSlice';
import langReducer from '../../store/lang/langSlice';
import loginReducer from '../../store/login/loginSlice';
import { rtkQueryLogger } from '../../store/middleware/rtkQueryLogger';
import tokenReducer from '../../store/tokenHandling/tokenHandlingSlice';
import widgetReducer from '../../store/widget/widgetSlice';

const rootReducer = combineReducers({
    app: appReducer,
    lang: langReducer,
    login: loginReducer,
    filter: filterReducer,
    tokenHandling: tokenReducer,
    widget: widgetReducer,

    [facadeApiV2.reducerPath]: facadeApiV2.reducer,
    [facadeApiV3.reducerPath]: facadeApiV3.reducer,
});

export const setupStore = (preloadedState?: RootState) => {
    return configureStore({
        reducer: rootReducer,
        preloadedState,

        // Adding the api middleware enables caching, invalidation, polling,
        // and other useful features of `rtk-query`.
        middleware: getDefaultMiddleware =>
            getDefaultMiddleware().concat(facadeApiV2.middleware).concat(facadeApiV3.middleware).concat(rtkQueryLogger),
        devTools: true,
    });
};
export const store = setupStore();

// Infer the `RootState` and `RootDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
export type RootDispatch = typeof store.dispatch;

// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);
